export default __webpack_public_path__ + "static/media/client-21.61db6936.png";